var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-width":"1400px","min-height":"900px"},attrs:{"id":"vssi-chart"}})])
}]

export { render, staticRenderFns }